import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { StatCard } from "@/components/common";
import { usd } from "@/lib/constants";
import { Building2, Home, TrendingUp, DollarSign, MapPin } from "lucide-react";

const IMGS = ["https://images.unsplash.com/photo-1721815693498-cc28507c0ba2", "https://images.pexels.com/photos/32666364/pexels-photo-32666364.jpeg"];

export default function Portfolio() {
  const [leads, setLeads] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/leads").then((r) => setLeads(r.data)); }, []);
  const acquired = leads.filter((l) => l.status === "Acquired" || l.status === "Under Contract" || l.status === "Closing Scheduled");

  const totalValue = acquired.reduce((s, l) => s + (Number(l.property?.estimated_market_value) || 0), 0);
  const totalRent = acquired.reduce((s, l) => s + (Number(l.property?.estimated_rent) || 0), 0);

  return (
    <div>
      <PageHeader title="Portfolio" subtitle="Acquired & pipeline properties under management" />
      <div className="p-4 sm:p-6 lg:p-8 space-y-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <StatCard label="Properties" value={acquired.length} icon={Building2} />
          <StatCard label="Portfolio Value" value={usd(totalValue)} icon={DollarSign} />
          <StatCard label="Monthly Rent" value={usd(totalRent)} icon={TrendingUp} />
          <StatCard label="Annual Rent" value={usd(totalRent * 12)} icon={Home} />
        </div>

        {acquired.length === 0 ? <div className="text-muted-foreground bg-card border border-border rounded-md p-10 text-center">No properties in portfolio yet. Move leads to Under Contract or Acquired.</div> :
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {acquired.map((l, idx) => (
              <div key={l.id} className="bg-card border border-border rounded-md overflow-hidden cursor-pointer hover:-translate-y-1 hover:shadow-sm transition-transform duration-200" onClick={() => nav(`/leads/${l.id}`)} data-testid={`portfolio-card-${l.id}`}>
                <div className="h-40 overflow-hidden"><img src={IMGS[idx % IMGS.length]} alt="Property" className="w-full h-full object-cover" /></div>
                <div className="p-5">
                  <div className="font-display font-bold truncate">{l.property?.property_address}</div>
                  <div className="text-xs text-muted-foreground flex items-center gap-1 mt-1"><MapPin className="w-3 h-3" />{l.property?.city}, {l.property?.state}</div>
                  <div className="flex justify-between mt-4 text-sm">
                    <div><div className="text-muted-foreground text-xs uppercase tracking-wider">Value</div><div className="font-mono-nums font-bold">{usd(l.property?.estimated_market_value)}</div></div>
                    <div className="text-right"><div className="text-muted-foreground text-xs uppercase tracking-wider">Status</div><div className="font-medium">{l.status}</div></div>
                  </div>
                </div>
              </div>
            ))}
          </div>}
      </div>
    </div>
  );
}
